import { Trash } from 'iconoir-react';
import { useCallback, useRef } from 'react';
import SignatureCanvasImport from 'react-signature-canvas';

import { $SignatureClearButton, $SignatureContainer } from './Signature.styles';

const SignatureCanvas =
  (
    SignatureCanvasImport as unknown as {
      default?: typeof SignatureCanvasImport;
    }
  ).default ?? SignatureCanvasImport;

interface SignatureProps {
  shouldCleanOnResize?: boolean;
  onUpdateSignature: (trimmedDataURL?: Base64URLString) => void;
}

export const Signature = ({
  shouldCleanOnResize = false,
  onUpdateSignature,
}: SignatureProps) => {
  const sigCanvas = useRef(null);

  const handleClearSignature = useCallback(() => {
    if (sigCanvas.current) {
      (sigCanvas.current as any).clear();
      onUpdateSignature(undefined);
    }
  }, [onUpdateSignature]);

  const handleSaveSignature = useCallback(() => {
    if (sigCanvas.current) {
      onUpdateSignature(
        (sigCanvas.current as any).getTrimmedCanvas().toDataURL('image/png'),
      );
    }
  }, [onUpdateSignature]);

  return (
    <$SignatureContainer>
      <SignatureCanvas
        ref={sigCanvas}
        clearOnResize={shouldCleanOnResize}
        onEnd={handleSaveSignature}
      />
      <$SignatureClearButton
        onClick={handleClearSignature}
        icon={<Trash />}
        rounded
        secondary
      />
    </$SignatureContainer>
  );
};
